export default __webpack_public_path__ + "static/media/whatsapp_icon.3978667a.png";